module.exports = __webpack_public_path__ + "static/media/svetielko.0e3ecbed.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/svetielko.png
// module id = 497
// module chunks = 0